export default {
    path: '/wecode/approvalright',
    auth: false,
    preload: false,
    key: 'form',
    isStatic: true,
    component: () => import('./index')
  };
  